import type { ICategoryInfo, ICategoryItem, ICategoryLinkGroup } from '~/modules/categories/types/categories';

/**
 * @deprecated
 */
export default (menuItems: any) => {
  // ---- Конвертер ----
  let idCounter = 1;

  function createCategoryUrlGenerator() {
    let id = 2;
    return function () {
      const url = `/catalog/category-${id}`;
      id = id < 5 ? id + 1 : 2;
      return url;
    };
  }

  // Пример использования:
  const getCategoryUrl = createCategoryUrlGenerator();

  function slugify(str: string): string {
    return str
      .toLowerCase()
      .replace(/[\s\/]+/g, '-')
      .replace(/[^\w-]/g, '')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function convertMenuItem(menu: any): ICategoryItem {
    const id = idCounter++;
    const slug = slugify(menu.label);

    const category: ICategoryInfo = {
      id,
      name: menu.label,
      slug,
      url: menu.url,
      // url: getCategoryUrl()
    };

    // Рекурсивно обрабатываем детей
    const children = menu.children && menu.children.length > 0
      ? menu.children.map(convertMenuItem)
      : undefined;

    // link_groups из columns типа text
    let link_groups: ICategoryLinkGroup[] | undefined = undefined;
    if (Array.isArray(menu.columns)) {
      link_groups = menu.columns
        .filter((col: any) => col.type === 'text')
        .flatMap((col: any) =>
          col.sections.map((section: any) => ({
            name: section.label,
            items: section.items.map((item: any) => ({
              id: idCounter++,
              name: item.label,
              slug: slugify(item.label),
              url: item.url,
              // url: getCategoryUrl()
            })),
          })),
        );
      if (link_groups && link_groups.length === 0) link_groups = undefined;
    }

    // brands
    let brands: any[] | undefined = undefined;
    brands = menu.columns
      .filter((col: any) => col.type === 'brands')
      .flatMap((col: any) =>
        col.sections.flatMap((section: any) =>
          section.items.map((item: any) => ({
            id: idCounter++,
            name: item.label,
            slug: slugify(item.label),
            url: item.url,
            // url: getCategoryUrl()
          })),
        ),
      );

    if (brands && brands.length === 0) brands = undefined;

    return {
      category,
      ...(children ? { children } : {}),
      ...(link_groups ? { link_groups } : {}),
      ...(brands ? { brands } : {}),
    };
  }

  function convertMenu(menuItems: any[]): ICategoryItem[] {
    return menuItems.map(convertMenuItem);
  }

  return convertMenu(menuItems);
};
